import { render, staticRenderFns } from "./InputDialog.vue?vue&type=template&id=4d0f97c9&"
import script from "./InputDialog.vue?vue&type=script&lang=ts&"
export * from "./InputDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports